import { ValidatorFn } from "@angular/forms";

export function MultiLanguageValidator(languages: string[]): ValidatorFn {
	return (control): { [key: string]: any } => {
		const value = control.value;

		if (!value) {
			return { languagesIncomplete: { valid: false } };
		}

		const keys = Object.keys(value);
		const hasAllKeys = languages.every((language) => keys.includes(language));
		let valid = hasAllKeys;

		if (!hasAllKeys) {
			return valid ? null : { languagesIncomplete: { valid: false } };
		}

		keys.forEach((key) => {
			if (!value[key]) {
				valid = false;
			}
		});

		return valid ? null : { languagesIncomplete: { valid: false } };
	};
}
